import { Skeleton, Stack } from '@mui/material'

/**
 * What a section shows while a page's chunk is still arriving.
 *
 * `fallback={null}` — what the app used before — flashes an empty page on a
 * cold chunk, and a screen that appears at its natural size afterwards shoves
 * the layout around. This is the same treatment `<Panel>` uses for its own
 * loading state, at roughly the height of a page, so nothing reflows.
 */
export function PageFallback() {
  return (
    <Stack spacing={2} aria-busy>
      <Skeleton variant="rounded" height={64} animation="wave" />
      <Skeleton variant="rounded" height={280} animation="wave" />
      <Skeleton variant="rounded" height={180} animation="wave" />
    </Stack>
  )
}
